import dayjs, { Dayjs } from 'dayjs';

import { Nullable } from 'v2/types';

export interface ExportRewardsForm {
  startDate: Nullable<Dayjs>;
  endDate: Nullable<Dayjs>;
}

export const initialValues: ExportRewardsForm = {
  startDate: null,
  endDate: dayjs(),
};
